// extracted by css-extract-rspack-plugin
export default {"shell":"SiteHeaderBar-module__shell","spacer":"SiteHeaderBar-module__spacer","spacerPhone":"SiteHeaderBar-module__spacerPhone"};